<template>
  <el-dialog
    :title="paymentTitle"
    :visible.sync="dialogVisible"
    width="70%"
    @close="handleClose"
  >
    <div v-loading="loading">
      <!-- 商品选择阶段 -->
      <div v-if="currentStep === 'selectProduct'">
        <div class="product-list">
          <div
            v-for="product in products"
            :key="product.goodsId"
            class="product-item"
            :class="{ active: selectedProduct === product.goodsId }"
            @click="selectProduct(product.goodsId)"
          >
            <div class="product-name">{{ product.name }}</div>
            <div style="padding: 10px">
              <span style="font-size: 14px">¥</span>
              <span class="product-amount">{{ product.price }}</span>
              <span class="product-market-price">
                ¥{{ product.marketPrice }}</span
              >
            </div>
            <div class="product-description">
              套餐流量： {{ product.trafficSize }}
            </div>
            <div class="product-description">
              有效期: {{ product.validDays }}天
            </div>
          </div>
        </div>

        <!-- 支付方式选择 -->
        <div class="payment-area">
          <div class="payment-method-section">
            <div class="section-title">支付方式</div>
            <div class="payment-methods">
              <el-radio-group
                v-model="selectedPaymentMethod"
                class="payment-method-radio-group"
              >
                <el-radio
                  v-for="method in paymentMethods"
                  :key="method.value"
                  :label="method.value"
                  class="payment-method-radio"
                >
                  <img
                    style="width: 20px; height: 20px"
                    src="@/assets/images/pay-wechat.jpg"
                    alt=""
                  />
                  <span>{{ method.label }}</span>
                </el-radio>
              </el-radio-group>
            </div>
          </div>
          <div class="payment-remark-section" v-if="selectedProduct != null">
            <div>当前账号:{{ userId }}</div>
            <div>
              选择套餐:{{
                selectedProductInfo == null ? "" : selectedProductInfo.name
              }}
              |
              {{
                selectedProductInfo == null
                  ? ""
                  : selectedProductInfo.trafficSize
              }}
              |
              {{
                selectedProductInfo == null
                  ? ""
                  : selectedProductInfo.validDays + "天"
              }}
            </div>
            <div>
              支付金额:
              <span style="color: red; padding-left: 5px; font-size: 18px"
                >¥{{
                  selectedProductInfo == null ? "" : selectedProductInfo.price
                }}</span
              >
            </div>
          </div>
        </div>
      </div>

      <!-- 支付二维码展示阶段 -->
      <div v-else-if="currentStep === 'showQrCode'">
        <div class="qr-code-container">
          <div ref="qrCodeRef" class="qr-code-image"></div>
          <p class="qr-code-tip">
            请使用{{ selectedPaymentMethodLabel }}扫码支付
          </p>
          <p class="order-amount">支付金额: ¥{{ selectedProductInfo.price }}</p>
          <p class="product-name">商品: {{ selectedProductInfo.name }}</p>
        </div>
      </div>

      <!-- 支付成功阶段 -->
      <div v-else-if="currentStep === 'paymentSuccess'">
        <div class="payment-success">
          <i class="el-icon-success success-icon"></i>
          <p class="success-text">支付成功</p>
          <p class="success-amount">
            支付金额: ¥{{ selectedProductInfo.price }}
          </p>
          <p class="product-name">商品: {{ selectedProductInfo.name }}</p>
          <p class="payment-method">
            支付方式: {{ selectedPaymentMethodLabel }}
          </p>
        </div>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <div v-if="currentStep === 'selectProduct'">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="confirmProduct"
          :disabled="!selectedProduct"
          >创建支付订单</el-button
        >
      </div>

      <div v-else-if="currentStep === 'showQrCode'">
        <el-button @click="cancelPayment">取 消</el-button>
        <!-- <el-button
          type="success"
          @click="checkPaymentStatus"
          :loading="checkingStatus"
        >
          检查支付状态
        </el-button> -->
      </div>

      <div v-else-if="currentStep === 'paymentSuccess'">
        <el-button type="primary" @click="finishPayment">完 成</el-button>
      </div>
    </span>
  </el-dialog>
</template>

<script>
import { payApi } from "@/utils/api";
import QRCode from "qrcodejs2";

export default {
  name: "RechargeDialog",
  data() {
    return {
      dialogVisible: false,
      currentStep: "selectProduct", // selectProduct, showQrCode, paymentSuccess
      paymentTitle: "流量包购买计划",
      products: [],
      selectedProduct: null,
      selectedProductInfo: null,
      qrCodeUrl: "",
      qrCodeInstance: null,
      orderNo: "",
      loading: false,
      checkingStatus: false,
      paymentTimer: null,
      // 支付方式选项
      paymentMethods: [
        { label: "微信支付", value: "wechat", icon: "el-icon-chat-dot-round" },
        // { label: '支付宝', value: 'alipay', icon: 'el-icon-bank-card' }
      ],
      selectedPaymentMethod: "wechat", // 默认选择微信支付
      userId: localStorage.getItem("userPhone") || "",
    };
  },
  computed: {
    isPaymentStep() {
      return this.currentStep === "showQrCode";
    },
    selectedPaymentMethodLabel() {
      const method = this.paymentMethods.find(
        (m) => m.value === this.selectedPaymentMethod
      );
      return method ? method.label : "";
    },
  },
  methods: {
    open() {
      this.dialogVisible = true;
      this.currentStep = "selectProduct";
      this.paymentTitle = "选择充值套餐";
      this.fetchProducts();
    },

    async fetchProducts() {
      this.loading = true;
      try {
        const response = await payApi.getProducts();
        this.products = response.data;
        this.loading = false;
        if (this.products && this.products.length > 0) {
          const productId = this.products[0].goodsId;
          this.selectedProduct = productId;
          this.selectedProductInfo = this.products[0];
        }
      } catch (error) {
        this.$message.error("获取商品列表失败: " + error.message);
        this.loading = false;
      }
    },

    selectProduct(productId) {
      this.selectedProduct = productId;
      this.selectedProductInfo = this.products.find(
        (p) => p.goodsId === productId
      );
    },

    // 选择支付方式
    selectPaymentMethod(method) {
      this.selectedPaymentMethod = method;
    },

    async confirmProduct() {
      if (!this.selectedProduct) {
        this.$message.warning("请选择充值套餐");
        return;
      }

      this.currentStep = "showQrCode";
      this.paymentTitle = "扫码支付";
      await this.generatePaymentQrCode();
    },

    async generatePaymentQrCode() {
      this.loading = true;
      try {
        const data = {
          goodsId: this.selectedProduct,
          payType: this.selectedPaymentMethod, // 使用选择的支付方式
        };

        const response = await payApi.getPaymentQrCode(data);
        this.qrCodeUrl = response.data.qrCodeUrl;
        this.orderNo = response.data.orderNumber;

        // 生成二维码
        this.$nextTick(() => {
          this.generateQRCode();
        });

        // 开始轮询支付状态
        this.startPaymentPolling();
        this.loading = false;
      } catch (error) {
        this.$message.error("生成支付二维码失败: " + error.message);
        this.loading = false;
      }
    },

    // 使用qrcodejs2生成二维码
    generateQRCode() {
      // 清除现有的二维码
      if (this.qrCodeInstance) {
        this.qrCodeInstance.clear();
        this.qrCodeInstance.makeCode(this.qrCodeUrl);
        return;
      }

      // 创建新的二维码
      this.$nextTick(() => {
        if (this.$refs.qrCodeRef) {
          this.qrCodeInstance = new QRCode(this.$refs.qrCodeRef, {
            text: this.qrCodeUrl,
            width: 200,
            height: 200,
            colorDark: "#000000",
            colorLight: "#ffffff",
            correctLevel: QRCode.CorrectLevel.H,
          });
        }
      });
    },

    startPaymentPolling() {
      // 每1秒检查一次支付状态
      this.paymentTimer = setInterval(() => {
        console.log("Checking payment status...");
        this.checkPaymentStatus(false);
      }, 1000);
    },

    async checkPaymentStatus(showMessage = true) {
      if (!this.orderNo) return;

      this.checkingStatus = true;
      try {
        const response = await payApi.checkPaymentStatus(this.orderNo);
        const status = response.data.payState;
        if (status === 20) {
          // 支付成功
          this.stopPaymentPolling();
          this.currentStep = "paymentSuccess";
          this.paymentTitle = "支付成功";

          if (showMessage) {
            this.$message.success("支付成功");
          }

          // 触发支付成功事件
          this.$emit("payment-success", response.data);
          // 通知 MainLayout 重新获取用户信息
          this.$emit("fetch-user-info");
        } else if (status === 10) {
          // 待支付
          if (showMessage) {
            this.$message.info("支付未完成，请继续支付");
          }
        } else if (status === 30) {
          // 支付失败
          if (showMessage) {
            this.$message.error("支付失败，请重新支付");
          }
        } else if (showMessage) {
          this.$message.info("支付未完成，请继续支付");
        }

        this.checkingStatus = false;
      } catch (error) {
        this.checkingStatus = false;
        if (showMessage) {
          this.$message.error("检查支付状态失败: " + error.message);
        }
      }
    },

    cancelPayment() {
      this.stopPaymentPolling();
      this.currentStep = "selectProduct";
      this.paymentTitle = "选择充值套餐";
      this.selectedProduct = null;
      this.selectedProductInfo = null;
      this.qrCodeUrl = "";
      this.orderNo = "";
      // 清除二维码实例
      if (this.qrCodeInstance) {
        this.qrCodeInstance.clear();
      }
    },

    stopPaymentPolling() {
      if (this.paymentTimer) {
        clearInterval(this.paymentTimer);
        this.paymentTimer = null;
      }
    },

    finishPayment() {
      this.dialogVisible = false;
      this.$emit("payment-finish");
    },

    handleClose() {
      this.stopPaymentPolling();
      this.selectedProduct = null;
      this.selectedProductInfo = null;
      this.qrCodeUrl = "";
      this.orderNo = "";
      this.currentStep = "selectProduct";
      this.paymentTitle = "选择充值套餐";
      this.selectedPaymentMethod = "wechat"; // 重置为默认支付方式
      // 清除二维码实例
      if (this.qrCodeInstance) {
        this.qrCodeInstance.clear();
        this.qrCodeInstance = null;
      }
      this.$emit("close");
    },
  },

  beforeDestroy() {
    this.stopPaymentPolling();
    // 清除二维码实例
    if (this.qrCodeInstance) {
      this.qrCodeInstance.clear();
      this.qrCodeInstance = null;
    }
  },
};
</script>

<style scoped>
.product-list {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10%;
}

.product-item {
  padding: 10px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
  text-align: center;
  width: 120%;
  height: 160px;
  background: url("@/assets/images/price-bg.png") no-repeat top;
  background-size: 290px 90px;
  text-align: left;
}

.product-item:hover {
  border-color: #42b983;
}

.product-item.active {
  border-color: #42b983;
  background-color: #f0f9ff;
  position: relative;
}

.product-item.active::after {
  content: "✓";
  position: absolute;
  bottom: 10px;
  right: 10px;
  color: #1890ff;
  font-size: 16px;
  font-weight: bold;
}

.product-name {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 3px;
  color: #333;
  padding: 10px;
}

.product-amount {
  font-size: 16px;
  font-weight: bold;
  color: blue;
  margin-bottom: 3px;
  padding: 10px;
}

.product-description {
  font-size: 14px;
  color: #000;
  margin-bottom: 3px;
  padding: 10px;
}

.product-market-price {
  font-size: 11px;
  color: #909399;
  text-decoration: line-through;
}

.payment-area {
  border: 1px solid #ebeef5;
  display: flex;
  width: 80%;
  margin-top: 10px;
}

/* 支付方式样式 */
.payment-method-section {
  /* margin-top: 15px; */
  padding: 10px;
  border-right: 1px solid #eee;
  flex: 2;
}

.payment-remark-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 5px 10px 5px 30px;
  height: 120px;
}

.section-title {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 8px;
  color: #606266;
}

.payment-methods {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.payment-method-radio-group {
  /* display: flex;
  flex-direction: row;
  justify-content: space-around; */
}

.payment-method-radio {
  /* flex: 1; */
  display: flex;
  align-items: center;
  /* justify-content: center; */
  margin-right: 0;
  margin-bottom: 0;
  padding: 5px;
}

.el-radio__label {
  display: flex;
  align-items: center;
  justify-content: center;
}

.payment-method-radio i {
  margin-right: 5px;
  font-size: 18px;
}

.payment-method-radio span {
  font-size: 20px;
  height: 20px;
  line-height: 20px;
  padding-left: 10px;
}

.qr-code-container {
  text-align: center;
}

.qr-code-image {
  width: 200px;
  height: 200px;
  margin: 0 auto 15px;
}

.qr-code-tip {
  margin-bottom: 8px;
  color: #606266;
}

.order-amount {
  font-size: 16px;
  font-weight: bold;
  color: #42b983;
  margin-bottom: 5px;
}

.payment-success {
  text-align: center;
  padding: 20px 0;
}

.success-icon {
  font-size: 40px;
  color: #67c23a;
  margin-bottom: 15px;
}

.success-text {
  font-size: 18px;
  margin-bottom: 8px;
  color: #606266;
}

.success-amount {
  font-size: 16px;
  font-weight: bold;
  color: #42b983;
  margin-bottom: 5px;
}

.payment-method {
  font-size: 13px;
  color: #909399;
}
</style>
